import 'swiper/swiper-bundle.css';

import Swiper from 'swiper';
import { type SwiperOptions } from 'swiper/types';

const swiperParams: SwiperOptions = {
  allowSlideNext: false,
  allowSlidePrev: false,
  allowTouchMove: false,
  simulateTouch: false,
  noSwiping: true,
  autoHeight: true,
  noSwipingClass: 'swiper-slide',
  pagination: {
    el: '.swiper-pagination',
    type: 'progressbar',
  },
};

const swiper = new Swiper('.swiper-container', swiperParams);

// Variablen zur Speicherung der Auswahlen
let selectedLocation = '';
let selectedBrand = '';

// Markenoptionen basierend auf dem Standort
const brandOptions = {
  Darmstadt: ['Volkswagen', 'Audi', 'VW Nutzfahrzeuge', 'Skoda'],
  Bensheim: ['Volkswagen', 'Audi'],
};

// Financial Service Links basierend auf Standort und Marke
const financialServiceLinks = {
  Darmstadt: {
    Volkswagen: {
      Garantieversicherung:
        'https://garantie.vwfs.de/vw-nw/getdata/companynumber/18461000/sellernumber/063000',
      'Wartung & Inspektion':
        'https://www.wartung-inspektion.vwfs.de/vw/getdata/companynumber/18461000/agentnumber//dealername/Autohaus+J.+Wiest+%26+S%C3%B6hne+Gesellschaft+mit+beschr%C3%A4nkter+Haftung/dealeraddress/Hilpertstr.+6/dealerpostalcode/64295/dealercity/Darmstadt',
      Kaufpreisschutz:
        'https://kaufpreisschutz.vwfs.de/vw-kps/getdata/companynumber/18461000/sellernumber/063000',
      'Kfz Versicherung':
        'https://autoversicherung.vwfs.de/vw-kfz/getdata/companynumber/18461000/sellernumber/063000',
    },
    Audi: {
      Garantieversicherung:
        'https://garantie.vwfs.de/audi-nw/getdata/companynumber/18461000/sellernumber/063000',
      'Wartung & Inspektion':
        'https://www.wartung-inspektion.vwfs.de/audi/getdata/companynumber/18461000/agentnumber/16095/dealername/Autohaus+J.+Wiest+%26+S%C3%B6hne+Gesellschaft+mit+beschr%C3%A4nkter+Haftung/dealeraddress/Hilpertstr.+6/dealerpostalcode/64295/dealercity/Darmstadt',
      Kaufpreisschutz:
        'https://kaufpreisschutz.vwfs.de/audi-kps/getdata/companynumber/18461000/sellernumber/063000',
      'Kfz Versicherung':
        'https://autoversicherung.vwfs.de/audi-kfz/getdata/companynumber/18461000/sellernumber/063000',
    },
    'VW Nutzfahrzeuge': {
      Garantieversicherung:
        'https://garantie.vwfs.de/vw-nw/getdata/companynumber/18434100/sellernumber/063105',
      'Wartung & Inspektion':
        'https://www.wartung-inspektion.vwfs.de/vwn/getdata/companynumber/18434100/agentnumber/11523/dealername/Autohaus+J.+Wiest+%26+S%C3%B6hne+GmbH/dealeraddress/Riedstr.+5/dealerpostalcode/64295/dealercity/Darmstadt',
      Kaufpreisschutz:
        'https://kaufpreisschutz.vwfs.de/vw-kps/getdata/companynumber/18434100/sellernumber/063105',
      'Kfz Versicherung':
        'https://autoversicherung.vwfs.de/vw-kfz/getdata/companynumber/18434100/sellernumber/063105',
    },
    Skoda: {
      Garantieversicherung:
        'https://garantie.vwfs.de/skoda-nw/getdata/companynumber/17540886/sellernumber/505088',
      'Wartung & Inspektion':
        'https://www.wartung-inspektion.vwfs.de/skoda/getdata/companynumber/17540886/agentnumber/04106/dealername/Wiest+Automobile+GmbH/dealeraddress/Hilpertstr.+6/dealerpostalcode/64295/dealercity/Darmstadt',
      Kaufpreisschutz:
        'https://kaufpreisschutz.vwfs.de/skoda-kps/getdata/companynumber/17540886/sellernumber/505088',
      'Kfz Versicherung':
        'https://autoversicherung.vwfs.de/skoda-kfz/getdata/companynumber/17540886/sellernumber/505088',
    },
  },
  Bensheim: {
    Volkswagen: {
      Garantieversicherung:
        'https://garantie.vwfs.de/vw-nw/getdata/companynumber/18435475/sellernumber/063101',
      'Wartung & Inspektion':
        'https://www.wartung-inspektion.vwfs.de/vw/getdata/companynumber/18435475/agentnumber/34291/dealername/Autohaus+Wiest+GmbH/dealeraddress/Robert-Bosch-Str.+17-19/dealerpostalcode/64625/dealercity/Bensheim',
      Kaufpreisschutz:
        'https://kaufpreisschutz.vwfs.de/vw-kps/getdata/companynumber/18435475/sellernumber/063101',
      'Kfz Versicherung':
        'https://autoversicherung.vwfs.de/vw-kfz/getdata/companynumber/18435475/sellernumber/063101',
    },
    Audi: {
      Garantieversicherung:
        'https://garantie.vwfs.de/audi-nw/getdata/companynumber/18435475/sellernumber/063101',
      'Wartung & Inspektion':
        'https://www.wartung-inspektion.vwfs.de/audi/getdata/companynumber/18435475/agentnumber/05760/dealername/Autohaus+Wiest+GmbH/dealeraddress/Robert-Bosch-Str.+17-19/dealerpostalcode/64625/dealercity/Bensheim',
      Kaufpreisschutz:
        'https://kaufpreisschutz.vwfs.de/audi-kps/getdata/companynumber/18435475/sellernumber/063101',
      'Kfz Versicherung':
        'https://autoversicherung.vwfs.de/audi-kfz/getdata/companynumber/18435475/sellernumber/063101',
    },
  },
};

// Event Listener für den "Jetzt starten"-Button
document.getElementById('start-button')?.addEventListener('click', () => {
  swiper.allowSlideNext = true;
  swiper.slideNext();
});

// Funktion zum Erstellen der Standort-Buttons mit deinem HTML-Aufbau
function createLocationButtons() {
  const locations = ['Darmstadt', 'Bensheim'];
  const locationContainer = document.getElementById('location-container');

  if (locationContainer) {
    locations.forEach((location) => {
      // Erstelle ein Div-Element entsprechend deinem HTML-Aufbau
      const locationDiv = document.createElement('div');
      locationDiv.className = 'padding-small background-color-white radius pointer-events-on';
      locationDiv.id = `location-${location.toLowerCase()}`;

      // Füge eventuelle weitere Attribute hinzu
      locationDiv.setAttribute('data-w-id', 'unique-id-for-' + location);

      // Füge den Inhalt hinzu
      locationDiv.innerHTML = `
        <div class="f-feature-icon-wrapper margin-0">
          <div class="display-inlineflex heading-large">${
            location === 'Darmstadt' ? 'DA' : 'BE'
          }</div>
        </div>
        <div>
          <div class="heading-medium">${location}</div>
          <p class="text-size-small">Ihr Wiest Group Standort in ${location}</p>
        </div>
      `;

      // Füge den Event Listener hinzu
      locationDiv.addEventListener('click', () => {
        selectedLocation = location;
        updateBrandOptions();
        swiper.allowSlideNext = true;
        swiper.slideNext();
      });

      // Füge das Element dem Container hinzu
      locationContainer.appendChild(locationDiv);
    });
  }
}

// Funktion zum Erstellen der Marken-Buttons mit deinem HTML-Aufbau
function updateBrandOptions() {
  const brandContainer = document.getElementById('brand-container');
  if (brandContainer) {
    brandContainer.innerHTML = '';
    brandOptions[selectedLocation].forEach((brand) => {
      // Erstelle ein Div-Element entsprechend deinem HTML-Aufbau
      const brandDiv = document.createElement('div');
      brandDiv.className = 'padding-small background-color-white radius pointer-events-on';
      brandDiv.id = `brand-${brand.toLowerCase().replace(/\s/g, '-')}`;

      // Füge den Inhalt hinzu
      brandDiv.innerHTML = `
        <div class="f-feature-icon-wrapper margin-0">
          <div class="display-inlineflex heading-large">${brand.charAt(0)}</div>
        </div>
        <div>
          <div class="heading-medium">${brand}</div>
          <p class="text-size-small">Wählen Sie ${brand}</p>
        </div>
      `;

      // Füge den Event Listener hinzu
      brandDiv.addEventListener('click', () => {
        selectedBrand = brand;
        updateFinancialServiceLinks();
        swiper.slideNext();
      });

      // Füge das Element dem Container hinzu
      brandContainer.appendChild(brandDiv);
    });
  }
}

// Funktion zum Aktualisieren der Financial Service Links
function updateFinancialServiceLinks() {
  const fsContainer = document.getElementById('financial-service-container');
  if (fsContainer) {
    fsContainer.innerHTML = '';
    const services = financialServiceLinks[selectedLocation][selectedBrand];
    for (const [serviceName, serviceLink] of Object.entries(services)) {
      // Erstelle ein Div-Element entsprechend deinem HTML-Aufbau
      const serviceDiv = document.createElement('div');
      serviceDiv.className = 'padding-small background-color-white radius pointer-events-on';

      // Füge den Inhalt hinzu
      serviceDiv.innerHTML = `
        <div class="f-feature-icon-wrapper margin-0">
          <div class="display-inlineflex heading-large">${serviceName.charAt(0)}</div>
        </div>
        <div>
          <div class="heading-medium">${serviceName}</div>
          <p class="text-size-small">Mehr erfahren</p>
        </div>
      `;

      // Füge den Event Listener hinzu
      serviceDiv.addEventListener('click', () => {
        window.open(serviceLink, '_blank');
      });

      // Füge das Element dem Container hinzu
      fsContainer.appendChild(serviceDiv);
    }
  }
}

// Rufe die Funktion zum Erstellen der Standort-Buttons auf
createLocationButtons();
